import { useEffect, useState } from "react"
import Select from 'react-select'
import { useSearchParams } from 'react-router-dom'
import Header from "../../../../../Components/Header/Header"
import Sidebar from "../../../../../Components/Sidebar/Sidebar"
import DeletePopup from "../../GardenPopup/DeletePopup"
import { AssignedMaintainanceWorkDeleteAPI, AssignedMaintainanceWorkTableDataAPI, AssignedMaintainanceWorkTableExportDataAPI } from "../../../../../Redux/WaterSupplyDashBoardSlice/AssignedMaintainanceWork/AssignedMaintainanceWorkSlice"
import { Loading } from "../../../../../Helper/Loading"
import { MainFeederLocationDataDDL } from "../../../../../Components/CommonDDL/MainFeederLocationDataDDL"
import { WardNameDataDDL } from "../../../../../Components/CommonDDL/WardNameDataDDL"
import { useAuthState } from "../../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import moment from 'moment'
import { WaterSupplyWorkPeriodDDLAPI } from "../../../../../Redux/DDLSlice"
import { WaterSupplyWorkPeriodDataDDL } from "../../../../../Components/CommonDDL/WaterSupplyWorkPeriodDataDDL"
import ViewURL from "../../../../../Components/ViewURL/ViewURL"
import { Pegination } from "../../../../../Components/Pegination/Pegination"
import { CommonForAllAssignedMaintainanceWorkExportData } from "./CommonForAllAssignedMaintainanceWorkExportPage"
import { TableNote } from "../../../../../Components/Note/Note"
import { TableDeleteNote } from "../../../../../Components/Note/TableDeleteNote"
import { WaterSupplyLocationDataDDL } from "../../../../../Components/CommonDDL/WaterSupplyLocationDataDDL"
import { DistributionLineLocationDataDDL } from "../../../../../Components/CommonDDL/DistributionLineLocationDataDDL"


export default function CommonForAllAssignWorkMaintainancePageData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let searchNametitle2 = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    // console.log(ApiFlag)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [ShowImagePopup, setshowImagePopup] = useState(false)
    const [Heading, setHeading] = useState('')
    const [WaterQualityPhPopupShow, setWaterQualityPhPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [WaterQualityChlorinePopupShow, setWaterQualityChlorinePopupShow] = useState()

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    // const [MainFeederLocationDDL, setMainFeederLocationDDL] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WaterSupplyLocationDDL, setWaterSupplyLocationDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WaterSupplyWorkPeriod, setWaterSupplyWorkPeriod] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? moment(date).endOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))

    const handleEditOnClick = (item) => {
        setWaterQualityChlorinePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setWaterQualityChlorinePopupShow(false)
    }
    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        // setMainFeederLocationDDL({
        //     ...MainFeederLocationDDL,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
        setWaterSupplyLocationDDL({
            ...WaterSupplyLocationDDL,
            ID: 0,
            Label: 'Select...',
        })
        setWaterSupplyWorkPeriod({
            ...WaterSupplyWorkPeriod,
            ID: 0,
            Label: 'Select...',
        })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }
    const handleShowImage = (Imageurl, heading) => {
        setshowImagePopup(true)
        setImagePopUpData(Imageurl)
        setHeading(heading)
    }

    useEffect(() => {
        const data = {

            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            // M_WS_LocationID: MainFeederLocationDDL.ID,
            M_WS_LocationID: DashProjectTypeId == "1" ? WaterSupplyLocationDDL.ID : JunctionNameDDL.ID,
            M_WS_WorkTypeID: 0,
            M_WS_WorkPeriodID: WaterSupplyWorkPeriod.ID,
            M_UserID: UserID,
            Flag: ApiFlag,
            token: token,
            From: From,
            To: To,
            DashProjectTypeId: DashProjectTypeId,
            handleAssignedMaintainanceWorkExport: handleAssignedMaintainanceWorkExport
        }
        if (WardName.ID !== 0) {
            dispatch(AssignedMaintainanceWorkTableDataAPI({ data }))
        }

    }, [IsPost, To, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.AssignedMaintainanceWorkTableData)


    const handleAssignedMaintainanceWorkExport = () => {
        const data = {

            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            // M_WS_LocationID: MainFeederLocationDDL.ID,
            M_WS_LocationID: DashProjectTypeId == "1" ? WaterSupplyLocationDDL.ID : JunctionNameDDL.ID,
            M_WS_WorkTypeID: 0,
            M_WS_WorkPeriodID: WaterSupplyWorkPeriod.ID,
            M_UserID: UserID,
            Flag: ApiFlag,
            token: token,
            From: '1',
            To: '99999',
            DashProjectTypeId: DashProjectTypeId
        }
        if (WardName.ID !== 0) {
            dispatch(AssignedMaintainanceWorkTableExportDataAPI({ data }))
        }

    }
    // , [IsPost, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.AssignedMaintainanceWorkTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            T_WS_AssignMaintenanceServicesID: item.t_wS_AssignMaintenanceServicesID,
            T_Distri_AssginWaterMaintenanceServicesID: item.t_Distri_AssginWaterMaintenanceServicesID,
            M_UserID: UserID,
            token: token,
            DashProjectTypeId: DashProjectTypeId,
            handleIsPost: handleIsPost
        }
        dispatch(AssignedMaintainanceWorkDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.AssignedMaintainanceWorkDeleteData)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    <div className="page-header ">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="data_mob">
                        <div className="row m-1 py-1 pb-4 master_border">
                            <div className='col-9'>
                                <h5 className="py-1">Assigned Work {searchNametitle2}</h5>
                            </div>
                            <div className='col-3 mar_add'>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <CommonForAllAssignedMaintainanceWorkExportData
                                                ExcelData={ExportTableData}
                                                name={`Assigned Work  ${searchNametitle2}`}
                                            // searchName={searchName}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row m-0">
                                <div className="col-12 py-1 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="row rounded2">
                                        <div className="col-md-4 col-12 col-lg-3">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"> <b>From Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="FromDate"
                                                    value={FromDate}
                                                    onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                />

                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4 col-lg-3">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="ToDate"
                                                    value={ToDate}
                                                    onChange={(e) => setToDate(e.target.value)}
                                                    min={FromDate}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4 col-lg-3 ">
                                            <WardNameDataDDL
                                                WardName={WardName}
                                                setWardName={setWardName}
                                                HWard={HWard}
                                                WLable={WLable}
                                            // Flag='ward'
                                            />
                                        </div>

                                        {/* <div className="col-12 col-md-4 col-lg-3 " >
                                            <MainFeederLocationDataDDL
                                                MainFeederLocationDDL={MainFeederLocationDDL}
                                                setMainFeederLocationDDL={setMainFeederLocationDDL}
                                                WardName={WardName}
                                            // Flag='ward'
                                            />

                                        </div> */}

                                        {
                                            DashProjectTypeId == '1' ?
                                                <div className="col-lg-3 col-md-6">
                                                    <WaterSupplyLocationDataDDL
                                                        WaterSupplyLocationDDL={WaterSupplyLocationDDL}
                                                        setWaterSupplyLocationDDL={setWaterSupplyLocationDDL}
                                                        WardName={WardName.ID}
                                                    // Flag='ward'
                                                    />
                                                </div>
                                                :
                                                <div className="col-lg-3 col-md-6">
                                                    <DistributionLineLocationDataDDL
                                                        DistributionLineLocationDDL={JunctionNameDDL}
                                                        setDistributionLineLocationDDL={setJunctionNameDDL}
                                                        WardName={WardName.ID}
                                                    // Flag='ward'
                                                    />
                                                </div>
                                        }

                                        <div className="col-lg-3 col-md-4">
                                            <WaterSupplyWorkPeriodDataDDL
                                                WaterSupplyWorkPeriod={WaterSupplyWorkPeriod}
                                                setWaterSupplyWorkPeriod={setWaterSupplyWorkPeriod}
                                                DashProjectTypeId={DashProjectTypeId}


                                            />

                                        </div>

                                        <div className="col-12 col-md-4 col-lg-3 mt-4 d-md-flex">
                                            <button type="button"
                                                className="btn-clear btn btn-primary mx-2"
                                                onClick={handleSearch}
                                            >
                                                Search</button>
                                            <button type="button"
                                                className="btn btn-outline-danger"
                                                onClick={handleClear}
                                            >
                                                Clear</button>
                                        </div>
                                    </div>

                                    <div className="row mob_table table-responsive">
                                        {
                                            searchNametitle2 == "Operation Completed" || searchNametitle2 == "Electric Completed" || searchNametitle2 == "Mechanical Completed" || searchNametitle2 == "Civil Completed" ?
                                                <></>
                                                : <TableDeleteNote />
                                        }
                                        <table id="totalordergenerated"
                                            cellPadding="0"
                                            cellSpacing="0"
                                            border="0"
                                            className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className="sr_no_col">Sr No.</th>
                                                    <th>Date</th>
                                                    <th>Work Name</th>
                                                    <th>Work Assigned By</th>
                                                    <th>Before Image</th>
                                                    {
                                                        searchNametitle2 == "Operation Completed" ?
                                                            <>
                                                                <th>After Image</th>
                                                            </>
                                                            : ''
                                                    }

                                                    {
                                                        searchNametitle2 == "Electric Completed" ?
                                                            <>
                                                                <th>After Image</th>
                                                            </>
                                                            : ''
                                                    }

                                                    {
                                                        searchNametitle2 == "Mechanical Completed" ?
                                                            <>
                                                                <th>After Image</th>
                                                            </>
                                                            : ''
                                                    }

                                                    {
                                                        searchNametitle2 == "Civil Completed" ?
                                                            <>
                                                                <th>After Image</th>
                                                            </>
                                                            : ''
                                                    }
                                                    {
                                                        searchNametitle2 == "Operation Pending" || searchNametitle2 == "Electric Pending" || searchNametitle2 == "Mechanical Pending" || searchNametitle2 == "Civil Pending" ?
                                                            <>
                                                                <th className='action_icon'>Action</th>
                                                            </>
                                                            : ''
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                        <tr style={{ width: '100%' }}>
                                                            <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                            <td style={{ whiteSpace: "nowrap" }}>{item.workAssingDate ? moment(item.workAssingDate).format('DD-MM-YYYY') : '-'}</td>
                                                            <td >{item.workName ? item.workName : '-'}</td>
                                                            <td>{item.workAssignedBy ? item.workAssignedBy : '-'}</td>

                                                            <td style={{ textAlign: "center" }}>
                                                                {
                                                                    (item.beforePhoto == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <>
                                                                            <i className="fa-solid fa-eye" title='View'
                                                                                style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                onClick={() => handleShowImage(item.beforePhoto, 'Photo')}
                                                                            ></i>
                                                                        </>
                                                                }
                                                            </td>

                                                            {
                                                                searchNametitle2 == "Operation Completed" ?
                                                                    <>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            {
                                                                                (item.afterPhoto == null) ?
                                                                                    <span>-</span>
                                                                                    :
                                                                                    <>
                                                                                        <i className="fa-solid fa-eye" title='View'
                                                                                            style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                            onClick={() => handleShowImage(item.afterPhoto, 'Photo')}
                                                                                        ></i>
                                                                                    </>
                                                                            }
                                                                        </td>
                                                                    </>
                                                                    : ''
                                                            }
                                                            {
                                                                searchNametitle2 == "Electric Completed" ?
                                                                    <>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            {
                                                                                (item.afterPhoto == null) ?
                                                                                    <span>-</span>
                                                                                    :
                                                                                    <>
                                                                                        <i className="fa-solid fa-eye" title='View'
                                                                                            style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                            onClick={() => handleShowImage(item.afterPhoto, 'Photo')}
                                                                                        ></i>
                                                                                    </>
                                                                            }
                                                                        </td>
                                                                    </>
                                                                    : ''
                                                            }
                                                            {
                                                                searchNametitle2 == "Mechanical Completed" ?
                                                                    <>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            {
                                                                                (item.afterPhoto == null) ?
                                                                                    <span>-</span>
                                                                                    :
                                                                                    <>
                                                                                        <i className="fa-solid fa-eye" title='View'
                                                                                            style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                            onClick={() => handleShowImage(item.afterPhoto, 'Photo')}
                                                                                        ></i>
                                                                                    </>
                                                                            }
                                                                        </td>
                                                                    </>
                                                                    : ''
                                                            }
                                                            {
                                                                searchNametitle2 == "Civil Completed" ?
                                                                    <>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            {
                                                                                (item.afterPhoto == null) ?
                                                                                    <span>-</span>
                                                                                    :
                                                                                    <>
                                                                                        <i className="fa-solid fa-eye" title='View'
                                                                                            style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                            onClick={() => handleShowImage(item.afterPhoto, 'Photo')}
                                                                                        ></i>
                                                                                    </>
                                                                            }
                                                                        </td>
                                                                    </>
                                                                    : ''
                                                            }
                                                            {
                                                                searchNametitle2 == "Operation Pending" || searchNametitle2 == "Electric Pending" || searchNametitle2 == "Mechanical Pending" || searchNametitle2 == "Civil Pending" ?
                                                                    <>
                                                                        {
                                                                            (moment(item.workAssingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                                <>
                                                                                    <td>
                                                                                        <DeletePopup
                                                                                            open={DeletePopupShow}
                                                                                            handleDeleteApi={handleDeleteApi}
                                                                                            item={item}
                                                                                        />
                                                                                    </td>
                                                                                </>
                                                                                :
                                                                                <td className="text-center">{'-'}</td>
                                                                        }
                                                                    </>
                                                                    : ''
                                                            }


                                                        </tr>
                                                    )) :
                                                        <td colSpan={15}>No data found</td>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {tableData && tableData.table && tableData.table.length > 0 &&
                                        <Pegination
                                            PerPageCount={PerPageCount}
                                            TotalCount={tableData.table[0].totalCount}
                                            setFrom={setFrom}
                                            setTo={setTo}
                                            setrowNo={setrowNo}
                                            CurrentPage={CurrentPage}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {
                ShowImagePopup &&
                <ViewURL
                    Heading={Heading}
                    ImagePopUpData={ImagePopUpData}
                    setshowImagePopup={setshowImagePopup}
                />
            }
        </div>


    )
}